import React from "react";
import { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";

import { ExpensePieChart } from "./ExpensePieChart.jsx"
import { IncomePieChart } from "./IncomePieChart.jsx"
import { ExpenseLineChart } from "./ExpenseLineChart.jsx";
import { IncomeLineChart } from "./IncomeLineChart.jsx";
import { ExpenseBarChart } from "./ExpenseBarChart.jsx";
import { IncomeBarChart } from "./IncomeBarChart.jsx";

import "./styles.css";

const DashboardPageContent = () => {
  return (
    <div className="bodyContent">
      <div className="col-md-6 text-left">
        <h1>Dashboard</h1>
        <p><em>View your saving and spending.</em></p>
      </div>
      <div className="row income-row">
        <Col>
            <div>
                <IncomePieChart />
            </div>
        </Col>
        <Col>
            <div>
                <IncomeBarChart />
            </div>
        </Col>
        <Col>
            <div>
                <IncomeLineChart />
            </div>
        </Col>
      </div>
      <br/>
      <br/>
      <div className="row expense-row">
        <Col>
            <div>
                <ExpensePieChart />
            </div>
        </Col>
        <Col>
            <div>
                <ExpenseBarChart />
            </div>
        </Col>
        <Col>
            <div>
                <ExpenseLineChart />
            </div>
        </Col>
      </div>
      <br/>
      <br/>
    </div>
  );
};

export default DashboardPageContent;